export default "<router-outlet>\n    <app-spinner [showSpinner]=\"showLoader\"></app-spinner>\n</router-outlet>"